(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.querySelectorAll('.collection-main').forEach((collection) => {
    const filterForm = collection.querySelector('.collection-main__filters');
    const filterToggle = collection.querySelector('[data-filter-toggle]');
    const filterClose = collection.querySelector('[data-filter-close]');
    const filterBackdrop = collection.querySelector('[data-filter-backdrop]');

    if (!filterForm || !filterToggle) return;

    const closeFilters = () => {
      filterForm.classList.remove('is-open');
      filterBackdrop?.classList.remove('is-open');
      filterToggle.setAttribute('aria-expanded', 'false');
      filterBackdrop?.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    };

    const openFilters = () => {
      filterForm.classList.add('is-open');
      filterBackdrop?.classList.add('is-open');
      filterToggle.setAttribute('aria-expanded', 'true');
      filterBackdrop?.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    };

    filterToggle.addEventListener('click', () => {
      filterForm.classList.contains('is-open') ? closeFilters() : openFilters();
    });

    filterClose?.addEventListener('click', closeFilters);
    filterBackdrop?.addEventListener('click', closeFilters);

    filterForm.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeFilters();
        filterToggle.focus();
      }
    });

    document.addEventListener('click', (event) => {
      if (!filterForm.classList.contains('is-open')) return;
      if (filterForm.contains(event.target) || filterToggle.contains(event.target)) return;
      closeFilters();
    });
  });

  document.querySelectorAll('.collection-main__filters').forEach((filterForm) => {
    const filters = filterForm.querySelectorAll('.collection-filter');

    filters.forEach((filter) => {
      filter.addEventListener('toggle', () => {
        if (!filter.open) return;

        filters.forEach((item) => {
          if (item !== filter) {
            item.open = false;
          }
        });
      });
    });

    document.addEventListener('click', (event) => {
      if (filterForm.classList.contains('is-open')) return;
      if (filterForm.contains(event.target)) return;

      filters.forEach((filter) => {
        filter.open = false;
      });
    });

    filterForm.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      filters.forEach((filter) => {
        filter.open = false;
      });
    });
  });

  document.querySelectorAll('.collection-main__filters input[type="checkbox"]').forEach((input) => {
    input.addEventListener('change', () => {
      input.form?.submit();
    });
  });

  document.querySelectorAll('.collection-main').forEach((collection) => {
    const buttons = collection.querySelectorAll('[data-collection-view]');
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const view = button.dataset.collectionView;
        collection.dataset.view = view;
        buttons.forEach((item) => {
          item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
        });
      });
    });
  });

  document.querySelectorAll('[data-sort-menu]').forEach((sortMenu) => {
    const toggle = sortMenu.querySelector('[data-sort-toggle]');
    const panel = sortMenu.querySelector('[data-sort-panel]');
    const input = sortMenu.querySelector('[data-sort-input]');
    const options = sortMenu.querySelectorAll('[data-sort-value]');

    if (!toggle || !panel || !input) return;

    const close = () => {
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    };

    const open = () => {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      panel.focus();
    };

    toggle.addEventListener('click', () => {
      panel.hidden ? open() : close();
    });

    options.forEach((option) => {
      option.addEventListener('click', () => {
        input.value = option.dataset.sortValue;
        sortMenu.submit();
      });
    });

    document.addEventListener('click', (event) => {
      if (!sortMenu.contains(event.target)) close();
    });

    sortMenu.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        close();
        toggle.focus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-size-guide-dialog]').forEach((dialog) => {
    const container = dialog.closest('[data-product-main]');
    if (!container) return;

    const triggers = container.querySelectorAll('[data-size-guide-open]');
    const closeButton = dialog.querySelector('[data-size-guide-close]');

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      });
    });

    if (closeButton) {
      closeButton.addEventListener('click', () => dialog.close());
    }

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        dialog.close();
      }
    });
  });

  document.querySelectorAll('[data-product-main]').forEach((container) => {
    const variantData = container.querySelector('[data-product-variants]');
    const productForm = document.getElementById(container.dataset.productFormId);
    const variantIdInput = productForm?.querySelector('[data-variant-id-input]');
    const addButton = productForm?.querySelector('[data-add-to-cart]');
    const stickyBar = container.querySelector('[data-product-sticky-atc]');
    const stickyButton = container.querySelector('[data-sticky-add-to-cart]');
    const priceContainer = container.querySelector('[data-product-price]');
    const stickyPriceContainer = container.querySelector('[data-product-sticky-price]');
    const skuContainer = container.querySelector('[data-product-sku]');
    const optionInputs = Array.from(productForm?.querySelectorAll('[data-option-position]') || []);
    const mediaItems = Array.from(container.querySelectorAll('[data-product-media-id]'));
    const mediaThumbs = Array.from(container.querySelectorAll('[data-product-media-thumb]'));
    const mediaDots = Array.from(container.querySelectorAll('[data-product-media-dot]'));
    const mediaCurrent = container.querySelector('[data-product-media-current]');
    const mediaPrev = container.querySelector('[data-product-media-prev]');
    const mediaNext = container.querySelector('[data-product-media-next]');
    const syncStickyVisibility = () => {
      if (!stickyBar || !addButton) return;

      const isMobile = window.matchMedia('(max-width: 900px)').matches;
      if (!isMobile) {
        stickyBar.classList.remove('is-visible');
        return;
      }

      const buttonRect = addButton.getBoundingClientRect();
      const mainButtonVisible = buttonRect.top < window.innerHeight && buttonRect.bottom > 0;
      stickyBar.classList.toggle('is-visible', !mainButtonVisible && window.scrollY > 80);
    };

    if (stickyBar && addButton) {
      const observer = 'IntersectionObserver' in window
        ? new IntersectionObserver(syncStickyVisibility, { threshold: 0.01 })
        : null;

      observer?.observe(addButton);
      window.addEventListener('scroll', syncStickyVisibility, { passive: true });
      window.addEventListener('resize', syncStickyVisibility);
      syncStickyVisibility();
    }

    const scrollToMedia = (media) => {
      if (!media) return;
      const mediaContainer = media.closest('.product-main__media');
      const isMobileCarousel = window.matchMedia('(max-width: 600px)').matches;

      if (mediaContainer && isMobileCarousel && !mediaContainer.classList.contains('product-main__media--thumbnail_viewer')) {
        const mediaContainerRect = mediaContainer.getBoundingClientRect();
        const mediaRect = media.getBoundingClientRect();
        mediaContainer.scrollTo({
          left: mediaRect.left - mediaContainerRect.left + mediaContainer.scrollLeft,
          behavior: 'smooth'
        });
        return;
      }

      media.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    };

    const setActiveMedia = (media) => {
      if (!media) return;
      const isThumbnailViewer = media.closest('.product-main__media--thumbnail_viewer');

      if (isThumbnailViewer) {
        container.querySelectorAll('[data-product-media-id]').forEach((item) => {
          item.classList.toggle('is-active', item === media);
        });
      }

      mediaThumbs.forEach((thumb) => {
        thumb.setAttribute('aria-current', thumb.dataset.productMediaThumb === media.dataset.productMediaId ? 'true' : 'false');
      });

      mediaDots.forEach((dot) => {
        dot.setAttribute('aria-current', dot.dataset.productMediaDot === media.dataset.productMediaId ? 'true' : 'false');
      });

      if (mediaCurrent) {
        const index = mediaItems.indexOf(media);
        mediaCurrent.textContent = String(index + 1);
      }
    };

    const activeMediaIndex = () => {
      const activeDot = mediaDots.find((dot) => dot.getAttribute('aria-current') === 'true');
      if (activeDot) {
        const index = mediaItems.findIndex((media) => media.dataset.productMediaId === activeDot.dataset.productMediaDot);
        if (index >= 0) return index;
      }

      return 0;
    };

    const setMediaByIndex = (index) => {
      if (mediaItems.length === 0) return;
      const nextIndex = Math.max(0, Math.min(index, mediaItems.length - 1));
      const media = mediaItems[nextIndex];
      scrollToMedia(media);
      media.focus({ preventScroll: true });
      setActiveMedia(media);
    };

    let mediaScrollFrame = null;
    const syncMediaFromScroll = () => {
      const mediaContainer = container.querySelector('.product-main__media:not(.product-main__media--thumbnail_viewer)');
      if (!mediaContainer) return;
      if (mediaScrollFrame) window.cancelAnimationFrame(mediaScrollFrame);

      mediaScrollFrame = window.requestAnimationFrame(() => {
        const containerRect = mediaContainer.getBoundingClientRect();
        let closestMedia = mediaItems[0];
        let closestDistance = Infinity;

        mediaItems.forEach((media) => {
          const mediaRect = media.getBoundingClientRect();
          const distance = Math.abs(mediaRect.left - containerRect.left);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestMedia = media;
          }
        });

        setActiveMedia(closestMedia);
      });
    };

    mediaThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const media = container.querySelector(`[data-product-media-id="${thumb.dataset.productMediaThumb}"]`);
        if (!media) return;

        if (!media.closest('.product-main__media--thumbnail_viewer')) {
          scrollToMedia(media);
        }

        media.focus({ preventScroll: true });
        setActiveMedia(media);
      });
    });

    mediaDots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const media = container.querySelector(`[data-product-media-id="${dot.dataset.productMediaDot}"]`);
        if (!media) return;
        scrollToMedia(media);
        media.focus({ preventScroll: true });
        setActiveMedia(media);
      });
    });

    mediaPrev?.addEventListener('click', () => setMediaByIndex(activeMediaIndex() - 1));
    mediaNext?.addEventListener('click', () => setMediaByIndex(activeMediaIndex() + 1));
    container.querySelector('.product-main__media:not(.product-main__media--thumbnail_viewer)')?.addEventListener('scroll', syncMediaFromScroll, { passive: true });

    if (mediaItems.length > 0) {
      setActiveMedia(mediaItems[0]);
    }

    if (!variantData || !variantIdInput || optionInputs.length === 0) return;

    const variants = JSON.parse(variantData.textContent);
    const formatMoney = (cents) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: Shopify.currency.active
        }).format(cents / 100);
      } catch (error) {
        return `$${(cents / 100).toFixed(2)}`;
      }
    };

    const selectedOptions = () => {
      const options = [];
      optionInputs.forEach((input) => {
        if (input.checked) {
          options[Number(input.dataset.optionPosition) - 1] = input.value;
        }
      });
      return options;
    };

    const findVariant = () => {
      const options = selectedOptions();
      return variants.find((variant) => {
        return variant.options.every((option, index) => option === options[index]);
      });
    };

    const setUnavailableOptions = () => {
      const currentOptions = selectedOptions();

      optionInputs.forEach((input) => {
        const position = Number(input.dataset.optionPosition) - 1;
        const testOptions = [...currentOptions];
        testOptions[position] = input.value;
        const matchingVariant = variants.find((variant) => {
          return variant.options.every((option, index) => option === testOptions[index]);
        });

        const unavailable = !matchingVariant || !matchingVariant.available;
        input.dataset.unavailable = unavailable ? 'true' : 'false';
        input.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
      });
    };

    const renderPrice = (variant) => {
      if (!variant) return;
      const compare = variant.compare_at_price;
      const current = formatMoney(variant.price);
      let priceHtml = '';

      if (compare && compare > variant.price) {
        priceHtml = `<span class="price price--sale"><span class="price__current">${current}</span><s class="price__compare">${formatMoney(compare)}</s></span>`;
      } else {
        priceHtml = `<span class="price"><span class="price__current">${current}</span></span>`;
      }

      if (priceContainer) {
        priceContainer.innerHTML = priceHtml;
      }

      if (stickyPriceContainer) {
        stickyPriceContainer.innerHTML = priceHtml;
      }
    };

    const syncButton = (button, variant) => {
      if (!button) return;

      if (!variant) {
        button.disabled = true;
        button.textContent = button.dataset.soldOutText;
        return;
      }

      button.disabled = !variant.available;
      button.textContent = variant.available ? button.dataset.availableText : button.dataset.soldOutText;
    };

    const scrollToVariantMedia = (variant) => {
      const mediaId = variant?.featured_media?.id || variant?.featured_image?.id;
      if (!mediaId) return;

      const media = container.querySelector(`[data-product-media-id="${mediaId}"]`);
      if (!media) return;

      if (!media.closest('.product-main__media--thumbnail_viewer')) {
        scrollToMedia(media);
      }

      media.focus({ preventScroll: true });
      setActiveMedia(media);
    };

    const updateVariant = () => {
      const variant = findVariant();
      setUnavailableOptions();

      if (!variant) {
        syncButton(addButton, null);
        syncButton(stickyButton, null);
        return;
      }

      variantIdInput.value = variant.id;
      renderPrice(variant);

      if (skuContainer) {
        skuContainer.textContent = variant.sku || '';
      }

      syncButton(addButton, variant);
      syncButton(stickyButton, variant);
      scrollToVariantMedia(variant);
    };
    optionInputs.forEach((input) => input.addEventListener('change', updateVariant));
    updateVariant();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-testimonials-slider]').forEach((slider) => {
    const slides = Array.from(slider.querySelectorAll('[data-testimonials-slide]'));
    const section = slider.closest('.testimonials');
    const previousButton = slider.querySelector('.testimonials__prev');
    const nextButton = slider.querySelector('.testimonials__next');
    const logoButtons = section ? Array.from(section.querySelectorAll('.testimonials__logo-btn')) : [];
    const autoplay = slider.dataset.autoplay === 'true';
    const delay = Number(slider.dataset.delay) || 7000;
    let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
    let intervalId;

    if (activeIndex < 0) {
      activeIndex = 0;
    }

    const showSlide = (index) => {
      activeIndex = (index + slides.length) % slides.length;

      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.toggleAttribute('hidden', !isActive);
      });

      logoButtons.forEach((button, buttonIndex) => {
        button.classList.toggle('is-active', buttonIndex === activeIndex);
      });
    };

    const restartAutoplay = () => {
      if (!autoplay || slides.length < 2) return;
      window.clearInterval(intervalId);
      intervalId = window.setInterval(() => showSlide(activeIndex + 1), delay);
    };

    previousButton?.addEventListener('click', () => {
      showSlide(activeIndex - 1);
      restartAutoplay();
    });

    nextButton?.addEventListener('click', () => {
      showSlide(activeIndex + 1);
      restartAutoplay();
    });

    logoButtons.forEach((button) => {
      button.addEventListener('click', () => {
        showSlide(Number(button.dataset.index) || 0);
        restartAutoplay();
      });
    });

    showSlide(activeIndex);
    restartAutoplay();
  });

  } catch(e) { console.error(e); }
})();
})();
